import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <div className="footer">
      <div className="fText">Copyright © 2022 Afroz Quraishi</div>
    </div>
  );
}
